import * as React from "react";
import { useState } from "react";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
import styled from "styled-components";
import { Container, Typography, Grid, Box, Button, CircularProgress } from "@mui/material";
import { FormPersonNatural } from "./PersonNatural";
import { FormProspect } from "./FormProspect";
import {
  validateExistsCmsLead,
  getCitiesByCountry,
  createAndUpdate,
  getUserByDocument,
  createCoutesie,
  getAssessorByVenue,
} from "../../../services/ApiGeneralService";
import { ModalSuccessOrError } from "../../modals/ModalSuccessOrError";
import axios from "axios";
import { redirectPage, pagesUrl } from "../../../utils/misc";
import useDebounce from "hooks/useDebounce";
import { useEffect } from "react";

import { createDealByQr } from "services/crm";
import TwoFactorAuthModal from "./components/TwoFactorAuthModal";

const Main = styled(Container)`
  padding: 30px;

  .customerInfo {
    background: #f7f7f7;
    border-radius: 10px;
  }

  padding: 5 px 15 px;

  .gridContainer {
    display: grid;
    grid-gap: 10px;
  }

  .gridItem {
    border-radius: 12px;
    padding: 0 16px;
    font-size: 12px;
    height: 40px;
    border: 1px solid #cecece;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.4s ease;
    margin: 0 15px 15px 0;
  }

  .selected {
    border: 1px solid transparent;
    background-color: #faeef0;
  }
`;

const MAX_AGE = 13;
const spacing = 2;
const PERSON_NATURAL = "Persona Natural";
const maxDate = dayjs(Date.now()).subtract(MAX_AGE, "years");

const CreateCrmLead = ({
  brand = "",
  venue = "",
  source = "",
  identificationTypes = [],
  genders = [],
  countries = [],
  cities = [],
  trainingGoals = [],
  origins = [],
  isMobile = false,
  setCities = () => { },
  returnParam = 0,
  isCourtesie = false
}) => {
  const stateDefault = {
    person_type: PERSON_NATURAL,
    birth_date: maxDate,
    venue_id: venue,
    source_id: source,
    brand_id: brand,
    terms_condition: false,
    training_goals: [],
    related_information: true,
    contact_email: true,
    contact_sms: true,
    contact_app: true,
    contact_whatsapp: true,
    contact_phone: true,
    user_assigned: null,
    codeDoubleAutentication: null,
    codeDoubleAutenticationDigitate: null
  };
  const { control, watch, setValue } = useForm();
  const [values, setValues] = useState(stateDefault);
  const [showForm, setShowForm] = useState("register");
  const [errors, setErrors] = useState({});
  const [fetchErrors, setFetchErrors] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [refreshForm, setRefreshFrom] = useState(false);
  const [ip, setIp] = useState("");
  const [disabledButton, setDisabledButton] = useState(false)
  const [assessors, setAssessors] = useState([]);


  const [loading, setLoading] = useState(false);

  // MODAL PARA LA DOBLE AUTENTICACION
  const [openModal, setOpenModal] = useState(false);
  const [code, setCode] = useState(null);
  const [timeLeft, setTimeLeft] = useState(300);

  //valid user exists
  const [userFound, setUserFound] = useState(null);
  const docDebounce = useDebounce(watch('document_number'), 500);
  const docTypeDebounce = useDebounce(watch('document_type_id'), 500);

  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 99);

  /**
   *
   * @param e event field
   */
  const handlerOnChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (errors[name]) {
      let dataErrors = errors;
      delete dataErrors[name];
      setErrors(dataErrors);
    }
    if (name === "country_id") {
      if (value !== values[name]) {
        handlerGetCitiesByCountry(value);
      }
    }
    setValues({ ...values, [name]: value });
  };

  const handlerOnChangeSelectMulti = (e) => {
    let data = values[e.target.name];
    if (data.includes(e.target.value)) {
      data = data.filter((item) => item !== e.target.value);
    } else {
      data.push(e.target.value);
    }
    setValues({ ...values, [e.target.name]: data });
  };

  /**
   *
   * @param render
   * @param name
   * @param rules
   * @returns {JSX.Element}
   */
  const newController = ({
    render = ({ field }) => <React.Fragment {...field}></React.Fragment>,
    name = "",
    rules = {},
  }) => {
    const dataRules = { ...rules, ["required"]: true };
    return (
      <Controller
        render={render}
        name={name}
        control={control}
        rules={dataRules}
      />
    );
  };


  /**
   * handler submit form
   */
  const handlerOnSubmit = () => {
    setLoading(true);
    let body = handlerBodyPersonNatural();
    createAndUpdate(body)
      .then((json) => {
        if (json.data.status === "error") {
          throw json.data.message;
        }
        if (json?.data?.status === "success" && json?.data?.message === "codigo enviado") {
          setCode(json.data?.data?.otp)
          setOpenModal(true)
          setTimeLeft(300)
        } else if (json.data.status === "success") {
          handleCreateCourtesie(json.data.data)
          setOpenDialog(true);
          setRefreshFrom(true);

          createDealByQr({
            id: userFound?.id ?? json?.data?.data?.id,
            document_number: userFound?.document ?? json?.data?.data?.document_number,
            document_type_id: userFound?.document_type ?? json?.data?.data?.document_type_id,
            venue_id: body?.venue_id ?? venue,
            type_afiliate: userFound ? userFound.type_afiliate : 'lead',
            assigned_user: body.user_assigned
          })
            .then((data) => {})
            .catch(console.error)


          setTimeout(() => {
            if (returnParam !== "1") {
              redirectPage(pagesUrl[brand])
            } else {
              setShowForm('register');
              setRefreshFrom(false);
              setValues(stateDefault);
            }
          }, 1500);
        }
      })
      .catch((error) => {
        setFetchErrors(error);
        handlerControlForm("register");
        setOpenDialog(true);
      })
      .finally(() => setLoading(false));
  };

  const handlerValidateForm = async () => {
    await handlerValidateFormPersonNatural(PERSON_NATURAL);
  };

  const handlerValidateFormPersonNatural = async (form = PERSON_NATURAL) => {
    const requiredFields = [
      {
        name: "document_type_id",
        label: "Tipo de identificación",
        type: "integer",
        form,
      },
      {
        name: "document_number",
        label: "Número de identificación",
        type: "string",
        form,
      },
      { name: "name", label: "Nombres", type: "string", form },
      { name: "lastname", label: "Apellidos", type: "string", form },
      { name: "email", label: "Correo electrónico", type: "email", form },
      { name: "phone", label: "Télefono", type: "phone", form },
      { name: "gender", label: "Género", type: "integer", form },
      { name: "birth_date", label: "Fecha de nacimiento", type: "date", form },
      { name: "country_id", label: "País", type: "integer", form },
      { name: "city_id", label: "Ciudad", type: "integer", form },
      { name: "address", label: "Dirección", type: "string", form },
      {
        name: "term_condition",
        label: "Terminos y Condiciones",
        type: "bool",
        form,
      },
      {
        name: "venue_id",
        label: "Sede",
        type: "integer",
        form,
      },
    ];

    let dataErrors = validate(requiredFields);
    setErrors(dataErrors);
    setLoading(true);
    const exists = await handlerValidateExists();
    if (exists instanceof Object) {
      const error = exists;
      const keys = Object.keys(error);
      keys.forEach((key) => {
        dataErrors = handlerPushError(error[key], key, dataErrors);
      });
      setErrors(dataErrors);
    }

    if (JSON.stringify(dataErrors) !== "{}") {
      handlerControlForm("register");
      setLoading(false);
    } else if (!userFound) {
      setLoading(false);
      handlerControlForm("prospect");
    } else {
      handlerOnSubmit();
    }
  };

  /**
   *
   * @param requiredFields
   * @returns {{}}
   */
  const validate = (requiredFields = []) => {
    let dataErrors = {};
    requiredFields.map((field) => {
      if (values[field.name]) {
        if (field.type === "email") {
          validateEmail(values[field.name], field, dataErrors);
        }
        if (field.type === "phone") {
          validatePhone(values[field.name], field, dataErrors);
        }
        if (field.type === "bool") {
          validateBoolean(values[field.name], field, dataErrors);
        }
      } else {
        if (field.type === "bool") {
          validateBoolean(values[field.name], field, dataErrors);
          if (field.name == 'term_condition' && !values.term_condition) {
            dataErrors["terms_condition"] = "Debes aceptar los Términos y Condiciones.";
          }
        } else {
          const message = `El campo ${field.label.toLowerCase()} es obligatorio.`;
          dataErrors = handlerPushError(message, field.name, dataErrors);
        }
      }
    });
    return dataErrors;
  };

  /**
   *
   * @param message
   * @param fieldName
   * @param dataErrors
   * @returns {{}}
   */
  const handlerPushError = (message = "", fieldName = "", dataErrors = {}) => {
    return { ...dataErrors, [fieldName]: [message] };
  };

  const validateEmail = (email, field, dataErrors = {}) => {
    const validateEmail = String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (!validateEmail) {
        const message = `El ${field.label.toLowerCase()} no es valido.`;
        handlerPushError(message, field.name, dataErrors);
    }
  };

  const validatePhone = (phone = 0, field = {}, dataErrors = {}) => {
    let value = phone.toString();
    let minLength = 10;
    let maxLength = 10;
    if (field.hasOwnProperty("minLength")) {
      minLength = field.minLength;
    }
    if (field.hasOwnProperty("maxLength")) {
      maxLength = field.maxLength;
    }
    if (value.length > maxLength) {
      const message = `El campo ${field.label.toLowerCase()} no puede tener más de ${maxLength} dígitos.`;
      handlerPushError(message, field.name, dataErrors);
    }
    if (value.length < minLength) {
      const message = `El campo ${field.label.toLowerCase()} debe tener mínimo ${minLength} dígitos.`;
      handlerPushError(message, field.name, dataErrors);
    }
  };

  const validateBoolean = (value = false, field = {}, dataErrors = {}) => {
    if (!value) {
      const message = `El campo ${field.label.toLowerCase()} debe estar marcado.`;
      handlerPushError(message, field.name, dataErrors);
    }
  };

  const handlerBodyPersonNatural = (params = null) => {
    if (values.hasOwnProperty("other_origin")) {
      values["origin_lead"] = values.other_origin;
    }

    if (userFound) {
      values['identity_user'] = {
        [`id_${userFound.type_afiliate}`]: userFound.id
      }
    }

    if (code) {
      values.codeDoubleAutentication = code
    }

    if (isCourtesie) {
      values.sales_source_id = values.source_id
    }

    if (params) {
      values.codeDoubleAutenticationDigitate = params
    }

    return {
      ...values,
      'last_name': values.lastname,
      'first_name': values.name,
      'full_name': values.name + " " + values.lastname,
      'terms_condition': values.term_condition,
      ["venue_id"]: values.venue_id ?? venue,
      ["birth_date"]: dayjs(values["birth_date"]).format("YYYY-MM-DD"),
      ["validate_exists"]: false,
      ["request_server"]: `IP: ${ip}, ${window.navigator.userAgent}`,
    };
  };

  const handlerControlForm = (showItem = "") => {
    setShowForm(showItem);
  };

  /**
   *
   * @param label
   * @param required
   * @returns {string}
   */
  const selfLabelInput = (label = "", required = true) => {
    if (required) {
      return `${label} *`;
    } else {
      return label;
    }
  };

  /**
   *
   */
  const handlerGetCitiesByCountry = async (countryId) => {
    setValues({ ...values, ["city_id"]: null });
    setCities([]);
    const response = await getCitiesByCountry(countryId);
    const cities = response.data.data;
    setCities(cities);
  };

  /**
   *
   */
  const handlerAsessorByVenue = async (venue) => {
    setValues({ ...values, ["user_assigned"]: null });
    setAssessors([]);
    const response = await getAssessorByVenue(venue);
    const assessor = response.data.data;
    setAssessors(assessor);
  };

  /**
   *
   * @returns {Promise<AxiosResponse<any>>}
   */
  const handlerValidateExists = () => {
    let body = {};
    if (values["document_type_id"] && values["document_number"]) {
      body["document_type_id"] = values.document_type_id;
      body["document_number"] = values.document_number;
    }
    if (values["email"]) {
      body["email"] = values.email;
    }
    return validateExistsCmsLead(body)
      .then((response) => {
        if (response.data.status === "error") {
          throw response.data.message;
        }
        if (response.data.status === "success") {
          return false;
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const stateButton = (data) => {
    setDisabledButton(data);
  }

  //get server ip

  const getIp = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIp(res.data.IPv4);
  };

  React.useLayoutEffect(() => {
    getIp();
  }, []);

  React.useEffect(() => {
    if (venue) {
      setValues({ ...values, venue_id: venue });
    }
  } , [venue]);

  useEffect(() => {
    setUserFound(null);
    if (docDebounce && docTypeDebounce) {
      getUserByDocument(docTypeDebounce, docDebounce)
        .then(({ data }) => {
          if (data?.data) {
            setUserFound(data.data[0])
          }
        })
        .catch(console.error)
    }
    handlerAsessorByVenue(venue);
  }, [docDebounce, docTypeDebounce])

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCreateCourtesie = (data) => {
    if (isCourtesie && (data?.id || data?.identity_user)) {
      const body = {
        "crm_leads_id": data?.id ?? Object.values(data?.identity_user)?.at(0),
        "user_creator": 2,
        "company_id": 1,
        "organization_id": 1,
        "brand_id": brand,
        "product_id": 10, //id de producto para que solo de una cortesia
        "document_number": data?.did || data?.document_number,
        "document_type": data?.document_type || data?.document_type_id,
        "daysToGive": 0,
        "date_start": "2024-06-19 00:00:00",
        "authorization_type": 3, // cortesia evento chico
        "venue_id": data?.venue_id ?? venue
      }

      createCoutesie(body, userFound?.type_afiliate ?? 'lead')
        .then(() => {
        })
        .catch(console.error)
    }
  }

  return (
    <Main maxWidth="sm">
      <ModalSuccessOrError
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        fetchErrors={fetchErrors}
        titleSuccess={"Datos registrados con éxito"}
        titleError={"¡Ups! Al parecer hubo un error"}
      />
      {/* start Modal */}
      <TwoFactorAuthModal
        open={openModal}
        onClose={handleCloseModal}
        setOpenDialog={setOpenDialog}
        setRefreshFrom={setRefreshFrom}
        setShowForm={setShowForm}
        setLoading={setLoading}
        handlerControlForm={handlerControlForm}
        handlerBodyPersonNatural={handlerBodyPersonNatural}
        returnParam={returnParam}
        brand={brand}
        setValues={setValues}
        isCourtesie={isCourtesie}
        venue={venue}
        userFound={userFound}
        source={source}
        setFetchErrors={setFetchErrors}
        setCodeDoubleValidation={setCode}
        loading={loading}
        fetchErrors={fetchErrors}
        timeLeft={timeLeft}
        setTimeLeft={setTimeLeft}
        showForm={showForm}
      />
      {/* end Modal */}
      {!refreshForm && (
        <form>
          <Grid container spacing={spacing}>
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent={"center"}>
                <Typography variant={"h3"} color={"primary"} align={"center"}>
                  Registrarse
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              {showForm === "register" && (
                <Typography variant={"inherit"} align={"center"} mb={3}>
                  Los campos marcados con * son obligatorios.
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormPersonNatural
                values={values}
                assessors={assessors}
                handlerOnChange={handlerOnChange}
                newController={newController}
                selfLabelInput={selfLabelInput}
                identificationTypes={identificationTypes}
                genders={genders}
                countries={countries}
                cities={cities}
                maxDate={maxDate}
                spacing={spacing}
                errors={errors}
                hidden={showForm === "prospect"}
                isMobile={isMobile}
                buttonDisble={stateButton}
                isCourtesie={isCourtesie}
                codeDoubleAutentication={code}
                minDate={minDate}
              />
              {showForm === "prospect" && (
                <FormProspect
                  values={values}
                  handlerOnChange={handlerOnChange}
                  handlerOnChangeSelectMulti={handlerOnChangeSelectMulti}
                  newController={newController}
                  selfLabelInput={selfLabelInput}
                  trainingGoals={trainingGoals}
                  origins={origins}
                  spacing={spacing}
                  isMobile={isMobile}
                />
              )}
            </Grid>
            <Grid
              container
              display={"flex"}
              justifyContent={"space-around"}
              padding={2}
            >
              <Grid
                item
                xs={showForm === "prospect" ? 12 : 6}
                mb={showForm === "prospect" ? 2 : 0}
              >
                <Button
                  variant={"contained"}
                  fullWidth
                  disabled={disabledButton}
                  onClick={async () => {
                    if (loading) return;

                    if (showForm === "prospect") {
                      handlerOnSubmit();
                    } else {
                      await handlerValidateForm();
                    }
                  }}
                >
                  {
                    loading ?
                      <CircularProgress color="inherit" />
                      :
                      <>
                        {showForm === "prospect" ? "Enviar" : "Siguiente"}
                      </>
                  }
                </Button>
              </Grid>
              {showForm === "prospect" && (
                <Grid item xs={showForm === "prospect" ? 12 : 6}>
                  <Button
                    onClick={() => handlerControlForm("register")}
                    fullWidth
                    variant={"outlined"}
                  >
                    Atrás
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </form>
      )}
    </Main>
  );
};

export { CreateCrmLead };
